import React from 'react'
import MuiDivider from '../../core-components/Divider'
import { Motif2DeprecationWarning } from '../../utils/internal'

export default function Divider() {
  Motif2DeprecationWarning('VerticalNav', 'GlobalNavigation')

  return <MuiDivider light />
}
